'use client';

import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl'
import Image from 'next/image';
import Link from 'next/link';
import ProtectedEmail from '@/components/ui-elements/ProtectedEmail';
import { fadeInUp, viewportOnce } from '@/lib/animations';

export const Footer = () => {
  const t = useTranslations('Footer')
  const year = new Date().getFullYear();

  return (
    <motion.footer
      className="w-full bg-dark text-white pt-12 pb-8 px-6 sm:px-10 lg:px-16"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeInUp}
    >
      <div className="max-w-8xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 pb-12 border-b border-gray-800">
          <div className="lg:col-span-6 flex flex-col space-y-5">
            <Link href={`/`} className="flex items-center gap-2 group w-fit">
              <div className="w-12 h-12 flex items-center justify-center">
                <Image width={42} height={42} src="/images/logo.webp" alt="MPay logo" />
              </div>
            </Link>

            <p className="text-sm text-gray-300 leading-relaxed max-w-sm">
              {t.rich('subtitle', {
                br: () => <br />,
              })}
            </p>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div className="flex flex-col space-y-3">
              <h4 className="text-xs font-bold tracking-wider text-gray-400 uppercase">
                {t('company')}
              </h4>
              <ul className="space-y-2.5 text-sm font-medium">
                <li>
                  <Link href={`#products-kuik`} className="hover:color-primary transition-colors">
                    {t('products')}
                  </Link>
                </li>
                <li>
                  <Link href={`#for-banks`} className="hover:color-primary transition-colors">
                    {t('for_banks')}
                  </Link>
                </li>
                <li>
                  <Link href={`#empsa`} className="hover:color-primary transition-colors">
                    {t('empsa')}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col space-y-3">
              <h4 className="text-xs font-bold tracking-wider text-gray-400 uppercase">
                {t('legal')}
              </h4>
              <ul className="space-y-2.5 text-sm font-medium">
                <li>
                  <Link href={`/privacy-policy`} className="hover:color-primary transition-colors">
                    {t('privacy_policy')}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="flex flex-col space-y-3 col-span-2 sm:col-span-1">
              <h4 className="text-xs font-bold tracking-wider text-gray-400 uppercase">
                {t('contact')}
              </h4>
              <ProtectedEmail
                encodedEmail="aW5mb0BtcGF5LmFs"
                className="text-sm font-medium hover:color-primary transition-colors break-all"
              />
              <h4 className='text-sm font-medium'>
                Twin Towers, Tower 1/11
              </h4>
              <h4 className='text-sm font-medium'>
                Tirana, Albania
              </h4>
              <h4 className="text-xs font-medium tracking-wider text-gray-400 uppercase">
                kuik
              </h4>
              <ul className="space-y-2.5 text-sm font-medium">
                <li>
                  <a
                    href="https://kuik.al"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:color-primary transition-colors"
                  >
                    {t('visit')} kuik.al
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-400 font-medium">
          <p>© {year} Mpay Albania. {t('all_rights_reserved')}</p>
        </div>

      </div>
    </motion.footer>
  );
}